import React from 'react'
import b1 from '../IMG/b1.jpg'
import b2 from '../IMG/b2.jpg'
export default function Baterias() {
  return (<>
  
  
  
  
  <div className="container-fluid">
    <h1 className='text-center '>Se cargan baterias de todo <span className='colorsito'>TIPO</span></h1>
   <div className="row">
    <div className="col  ">
<div className="card">
  <img src={b1} className="card-img-top" alt="BATERIA-VEHICULOS"/>
  <div className="card-body">
    <h5 className="card-title">Batería de Vehiculos</h5>
    <p className="card-text">Cargamos, revivimos y mantenemos las baterías de tu  vehículos sanos.</p>
   
  </div>
</div>
    </div>
    <div className="col">

<div className="card">
  <img src={b2} className="card-img-top " alt="BATERIA-MOTOCICLETA"/>
  <div className="card-body">
    <h5 className="card-title">Batería de Motocicletas</h5>
    <p className="card-text ">Contamos con varios cargadores para poder cargas varias baterías de motocicletas a la vez</p>
   
  </div>
</div>

    </div>
   </div>
  </div>
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  </>
   
  )
}
